import {useState} from '@wordpress/element'
import {BaseProps} from "../types";

export default function SchoolMap(props: BaseProps) {
  const schools = props.data || []
  const [selected, setSelected] = useState<string>('https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3918.983723491067!2d106.67008770000001!3d10.812557199999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3175298edfe05f7d%3A0x41bfc33437ec96b0!2zVHLGsOG7nW5nIFBoaSBjw7RuZyBCYXkgVmnhu4d0!5e0!3m2!1sen!2s!4v1727021535236!5m2!1sen!2s')

  const onMapChange = (map: any) => {
    setSelected(map.url)
  }

  if (!Array.isArray(schools)) return null


  return (
    <div>
      <iframe
        src={selected}
        width="100%" height="505" frameBorder="0" style={{ border: 0 }} allowFullScreen aria-hidden="false"
      ></iframe>
      <div
        className="mt-8 grid grid-cols-1 lg:grid-cols-2 gap-4 text-left text-xl text-darkslategray-100 font-archivo">
        {schools.map(school => (
          <div>
            <p className="[margin-block-start:0] [margin-block-end:10px]">
              <b>{school.name}</b>
            </p>
            <p className="m-0 text-dimgray">
              <i>{school.description}</i>
            </p>
            <div className={'italic cursor-pointer'} onClick={() => onMapChange(school)}>
              Xem trên bản đồ
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}